import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptEditorViewModule } from "@common/ux/html-editor/editor-view.module";
import { AdaptLinkDisabledModule } from "@common/ux/link-disabled/link-disabled.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptSeeMoreModule } from "@common/ux/see-more/see-more.module";
import { AdaptStopPropagationDirective } from "@common/ux/stop-propagation.directive";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptArchitectureModule } from "@org-common/lib/architecture/architecture.module";
import { TeamCardComponent } from "@org-common/lib/architecture/organisation-map/team-card/team-card.component";
import { AdaptCallToActionModule } from "@org-common/lib/call-to-action/call-to-action.module";
import { AdaptDirectorySharedModule } from "@org-common/lib/directory-shared/directory-shared.module";
import { AdaptLabellingModule } from "@org-common/lib/labelling/labeling.module";
import { AdaptTeamDashboardSharedModule } from "@org-common/lib/teams/team-dashboard-shared/team-dashboard-shared.module";
import { TeamMembershipComponent } from "@org-common/lib/teams/team-membership/team-membership.component";
import { AdaptZoneMapModule } from "@org-common/lib/zone-map/zone-map.module";
import { AdaptSystemisationModule } from "app/features/systemisation/systemisation.module";
import { DxListModule, DxSelectBoxModule, DxTextBoxModule } from "devextreme-angular";
import { CollapseDirective } from "ngx-bootstrap/collapse";
import { SortablejsModule } from "nxt-sortablejs";
import { AdaptProcessMapSharedModule } from "../process-map/process-map-shared.module";
import { ListEntitiesInLocationComponent } from "./list-entities-in-location/list-entities-in-location.component";
import { OrganisationExplorerComponent } from "./organisation-explorer/organisation-explorer.component";
import { RenderOrganisationMapComponent } from "./render-organisation-map/render-organisation-map.component";


@NgModule({
    imports: [
        CommonModule,
        AdaptZoneMapModule,
        AdaptCommonDialogModule,
        AdaptLoadingSpinnerModule,
        CommonModule,
        AdaptLoadingSpinnerModule,
        AdaptDirectorySharedModule,
        AdaptProcessMapSharedModule,
        AdaptTeamDashboardSharedModule,
        AdaptSystemisationModule,
        AdaptLabellingModule,
        AdaptCallToActionModule,
        AdaptButtonModule,
        AdaptTooltipModule,
        DxListModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        AdaptLinkDisabledModule,
        SortablejsModule,
        AdaptStopPropagationDirective,
        CollapseDirective,
        AdaptMenuModule,
        TeamCardComponent,
        TeamMembershipComponent,
        AdaptSeeMoreModule,
        AdaptArchitectureModule,
        AdaptEditorViewModule,
    ],
    exports: [
        RenderOrganisationMapComponent,
        ListEntitiesInLocationComponent,
        OrganisationExplorerComponent,
    ],
    declarations: [
        RenderOrganisationMapComponent,
        ListEntitiesInLocationComponent,
        OrganisationExplorerComponent,
    ],
})
export class AdaptOrganisationMapModule {}
